import "./Manufacturing.css";

import {
  FaTruckLoading,
  FaIndustry,
  FaSearch,
  FaBoxOpen,
  FaShippingFast,
} from "react-icons/fa";

function Manufacturing() {
  const process = [
    {
      icon: <FaTruckLoading />,
      title: "Raw Material",
      text: "Premium quality raw materials sourced from trusted suppliers.",
    },

    {
      icon: <FaIndustry />,
      title: "Manufacturing",
      text: "Advanced production processes ensuring precision and consistency.",
    },

    {
      icon: <FaSearch />,
      title: "Quality Inspection",
      text: "Every product undergoes strict quality checks before dispatch.",
    },

    {
      icon: <FaBoxOpen />,
      title: "Packaging",
      text: "Secure packaging to ensure product protection during transit.",
    },

    {
      icon: <FaShippingFast />,
      title: "Dispatch",
      text: "Reliable logistics and timely delivery across India.",
    },
  ];

  return (
    <section className="manufacturing-section">
      <div className="container-custom">
        <div className="section-heading manufacturing-heading">
          <span>MANUFACTURING EXCELLENCE</span>

          <h2>From Raw Material To Reliable Delivery</h2>

          <p>
            Every packaging solution follows a carefully controlled
            manufacturing process focused on quality, precision and customer
            satisfaction.
          </p>
        </div>

        <div className="timeline">
          {process.map((step, index) => (
            <div className="timeline-item" key={index}>
              <div className="timeline-icon">{step.icon}</div>

              <h4>{step.title}</h4>

              <p>{step.text}</p>

              {index !== process.length - 1 && (
                <div className="timeline-line"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Manufacturing;
